require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./hotpepper-beauty.json") })
        }
      }, "path---hotpepper-beauty");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---hotpepper-beauty!./.cache/json/hotpepper-beauty.json
// module id = 337
// module chunks = 231608221292675